import React from 'react';
import { Provider, ProviderProps } from 'react-redux';
import { ConnectedRouter, ConnectedRouterProps } from 'connected-react-router';
import { renderRoutes } from 'react-router-config';

import { Title } from '../../withTitle';
import { AppProviders } from '../../contexts/index';
import { getRoutesWithStore } from '../../routes';

type AppEntryProps = {
  store: ProviderProps['store'];
  history: ConnectedRouterProps<any>['history'];
};

const AppEntry = ({ store, history }: AppEntryProps) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppProviders>
        <Title />
        {renderRoutes(getRoutesWithStore(store) as any)}
      </AppProviders>
    </ConnectedRouter>
  </Provider>
);
export { AppEntry };
